(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-gallery-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('orayta-art-carousel')) {
  customElements.define('orayta-art-carousel', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      const track=this.querySelector('.oe-carousel-track');
      const cards=[...track.children];
      const controls=this.querySelector('.oe-carousel-controls');
      const buttons=[...controls.querySelectorAll('button')];
      const count=controls.querySelector('.oe-carousel-count');
      const rtl=getComputedStyle(track).direction==='rtl';
      const position=()=>{
        const box=track.getBoundingClientRect();
        let nearest=0, distance=Infinity;
        cards.forEach((card,i)=>{const r=card.getBoundingClientRect();const d=Math.abs(rtl?box.right-r.right:r.left-box.left);if(d<distance){distance=d;nearest=i;}});
        return nearest;
      };
      const update=()=>{
        const max=track.scrollWidth-track.clientWidth;
        const offset=Math.abs(track.scrollLeft);
        controls.hidden=max<2;
        buttons[0].disabled=offset<2;
        buttons[1].disabled=offset>=max-2;
        count.textContent=`${position()+1} / ${cards.length}`;
      };
      const move=step=>{
        const width=cards[0]?.getBoundingClientRect().width||track.clientWidth;
        const gap=parseFloat(getComputedStyle(track).columnGap)||0;
        track.scrollBy({left:step*(width+gap)*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.step))));
      track.addEventListener('keydown',event=>{
        if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();move((event.key==='ArrowLeft'?1:-1)*(rtl?1:-1));
      });
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update);this.observer.observe(track);update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-scroll-story"] && !Shopify.designMode) return;
  try {
    
(function(){
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function init(scope){scope.querySelectorAll('[data-scroll-story]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const img=root.querySelector('[data-story-image]'),count=root.querySelector('[data-story-count]'),bar=root.querySelector('[data-story-progress]'),copy=root.querySelector('.or-story-copy');
 const close=root.querySelector("[data-story-close]");
 const frames=[1.12,1.11,1.1,1.09,1.08,1.065,1.05,1.035,1.02,1];
 let ticking=false,active=false;
 function draw(){ticking=false;if(!root.isConnected)return;
 const r=root.getBoundingClientRect(),distance=root.offsetHeight-root.querySelector('.or-story-stage').offsetHeight;
 const p=reduced.matches?1:Math.max(0,Math.min(1,-r.top/Math.max(1,distance)));
 const n=p*9,i=Math.min(8,Math.floor(n)),t=n-i;
 const scale=frames[i]+(frames[i+1]-frames[i])*t;
 img.style.transform='scale('+scale.toFixed(4)+')';
 close.style.transform='scale(1)';close.style.opacity=reduced.matches?0:Math.max(0,Math.min(1,1-(p-.32)/.28));
 count.textContent=String(Math.min(10,Math.floor(n)+1)).padStart(2,'0')+' / 10';
 bar.style.transform='scaleX('+p+')';copy.style.opacity=Math.max(0,(p-.87)/.13);
 }
 function schedule(){if(active&&!ticking){ticking=true;requestAnimationFrame(draw)}}
 const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;img.style.willChange=active?'transform':'auto';if(active)draw()},{rootMargin:'200px'});observer.observe(root);
 window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});reduced.addEventListener('change',draw);draw();
 });}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
